import { Logo } from '@/assets';
import { cn } from '@/lib/utils';

const PoweredBy = ({ className }: { className?: string }) => {
  return (
    <div className={cn('flex items-center justify-center gap-1.5', className)}>
      <span className="text-xs font-bold uppercase tracking-wider text-[#9aa0a8]">
        Powered by
      </span>
      <Logo className="size-4" />
      <span className="text-sm font-semibold text-[#6b7079]">
        123jobs.com<sup className="align-super text-[8px]">TM</sup>
      </span>
    </div>
  );
};

export default PoweredBy;
